function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.5 0C3.364 0 0 3.365 0 7.5 0 11.636 3.365 15 7.5 15c4.136 0 7.5-3.364 7.5-7.5S11.636 0 7.5 0zm0 13.5c-3.308 0-6-2.692-6-6s2.692-6 6-6 6 2.692 6 6-2.692 6-6 6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.49 9.472c-.257.29-.56.522-.895.684a2.508 2.508 0 01-1.897.118c-.626-.21-1.167-.66-1.532-1.274L4 9.892a4.59 4.59 0 001.14 1.291c.457.35.97.595 1.511.72.56.13 1.138.13 1.699 0a3.952 3.952 0 001.51-.72c.22-.169.431-.365.624-.582.191-.217.366-.456.516-.71L9.834 9a3.15 3.15 0 01-.344.472zM5 7a1 1 0 100-2 1 1 0 000 2zM10 7a1 1 0 100-2 1 1 0 000 2z"
}))));